import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { IDictionary } from '../../../../core/interfaces/IDictionary';
import { ToolsService } from '../../../../core/services/ToolsService';
import { DictionaryKeys } from '../../../../core/enums/DictionaryKeys';

export const deliveryMethodsResolver: ResolveFn<IDictionary> = (): Observable<IDictionary> =>
  inject(ToolsService).getDictionaryValue(DictionaryKeys.DeliveryMethods);
